import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  private sectionSubject: BehaviorSubject<string> = new BehaviorSubject<string>('#main');

  constructor(private httpClient: HttpClient) {}

  getActiveSection(): string {
    return this.sectionSubject.value ?? 0;
  }

  setActiveSection(value: string): void {
    this.sectionSubject.next(value);
  }

}
